import { isSafari } from './domUtils';

// export for testing purpose
export const getBinaryFromDataUrl = (binary) => {
  if (!binary.indexOf('data:')) {
    const match = binary.match(/.*,(.*)/);
    binary = match?.[1] || binary;
    binary = atob(binary);
  }

  return binary;
};

const getBlob = (bytes, data) =>
  new Blob([bytes], {
    type: data.type,
  });

const getFile = (bytes, data) =>
  new File([bytes], data.name, {
    type: data.type,
    lastModified: data.lastModified,
  });

export default async (binary, data) => {
  binary = getBinaryFromDataUrl(binary);

  const bytes = new Uint8Array(binary.length);

  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }

  let file;

  try {
    file = isSafari() ? getBlob(bytes, data) : getFile(bytes, data);
  } catch (e) {
    file = getBlob(bytes, data);
  }

  return file;
};
